import DeleteMobilization from "@/v2/api/mobilization/Delete";
import DeleteButton from "../general/Delete";

export default function MobilizationDeleteButton({
    id,
    isInside = false,
}: {
    id: string;
    isInside?: boolean;
}) {
    return (
        <DeleteButton
            id={id}
            queryKey={["mobilizations"]}
            deleteFn={DeleteMobilization}
            title="Delete Mobilization"
            description="Are you sure you want to delete this mobilization record? This action cannot be undone. Click delete to confirm."
            successTitle="Mobilization Deleted Successfully"
            isInside={isInside}
        />
    );
}
